import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithQueryParams } from "@utils/http-util";
import { QueryParameter } from "@idw-types/common";
import { AlertEventHistory } from "@idw-types/data/alert-event-history";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";

type GetAlertEventsRequestResponse = {
    alertEventHistories: Array<AlertEventHistory>;
};

export const getAlertEventsRequest = async (
    companyIds: Array<string>,
    alertIds: Array<string>,
    startDate: string,
    endDate: string,
    timeZone: string,
    dateFormat: string
): Promise<GenericNetworkResponse<GetAlertEventsRequestResponse>> => {
    const route = apiRoutes.alerts.alertEvent.search;
    const queryParameters: Array<QueryParameter> = [];

    if (companyIds?.length > 0) {
        queryParameters.push({ parameter: "companyID", value: companyIds.join(",") });
    }
    if (alertIds?.length > 0) {
        queryParameters.push({ parameter: "alertID", value: alertIds.join(",") });
    }
    if (startDate) {
        queryParameters.push({ parameter: "startDate", value: startDate });
        queryParameters.push({ parameter: "dateTriggeredStartDate", value: startDate });
    }
    if (endDate) {
        queryParameters.push({ parameter: "endDate", value: endDate });
        queryParameters.push({ parameter: "dateTriggeredEndDate", value: endDate });
    }
    if (timeZone) {
        queryParameters.push({ parameter: "timeZone", value: timeZone });
    }

    queryParameters.push({ parameter: "dateFormat", value: dateFormat })

    const { data, error } = await handleRequestWithQueryParams(RequestTypes.GET, route, queryParameters);
    return { data, error, queryParameters };
};